<template>
<v-container class="align-center" fill-height max-width="200">
    <div class="text-xs-center" >
      <v-flex  >
        <v-card class="rounded">
          <v-card-title>
            Please select Location to generate TimeClock report
          </v-card-title>
        </v-card>
        <LocationAutocomplete
          noClear=true
          @selected="selectedLocation">
        </LocationAutocomplete>
        <v-card-text v-if="location">
          <v-btn @click="generateReport">
            Generate
          </v-btn>
        </v-card-text>
      </v-flex>
    </div>
</v-container>
</template>
<script>
import employeeService from '../../Employee/service.js';
import locationService from '../service';
import EmployeeAutocomplete from '@/modules/Employee/components/AutoComplete';
import LocationAutocomplete from '@/modules/Location/components/AutoComplete';

export default {
  name: 'reports-timeClock',
  components: {
    EmployeeAutocomplete,
    LocationAutocomplete,
  },
  data() {
    return {
      locations: [],
      employees: [],
      employee: null,
      location: null,
    }
  },
  async created() {
    
    this.employees = (await employeeService.getAll({ lite: true })).data
  },
  methods: {
    selectedLocation(val) {
      if (val) {
        this.location = val.location;
      }
    },
    generateReport() {
      if (this.$route.params && this.$route.params.LocationId) {
        
        this.$router.push({
          name: "reports-timeClock-list",
          params: { 
            EmployeeId: this.$route.params.EmployeeId,
            LocationId: this.location,
          }
        })
      } else {
        
        this.$router.push({
          name: "reports-timeClock-list",
          params: { LocationId: this.location }
        })
      }
    }
  }
}
</script>
